import { PicklistItem, PicklistService } from '@recruiting-solutions/rs-shared';
import { FormService } from './form.service';

export interface FormServicePicklist {
    name: string;
    picklist?: string;
    optionValues: PicklistItem[];
}

export type HTMLFormServicePicklist = HTMLElement & FormServicePicklist;

export class FormPicklistService {
    elementsPicklist = ['csb-picklist', '[csb-picklist]'];

    constructor(private formService: FormService) {}

    async loadPicklistData(locale: string, additionalPicklistIds?: string[]): Promise<{ [key: string]: PicklistItem[] }> {
        if (!additionalPicklistIds) {
            additionalPicklistIds = [];
        }
        let elements = this.formService.querySelectorAll<HTMLFormServicePicklist>(this.elementsPicklist);

        let picklistIds = elements.map(e => e?.picklist || '').filter(n => n);
        picklistIds = [...new Set([...picklistIds, ...additionalPicklistIds])]; // remove duplicates. this can happen when mutliple templates are in the same page.

        if (picklistIds && picklistIds.length == 0) {
            return {};
        }

        let picklistData = await PicklistService.getMultiple(picklistIds, locale);
        if (picklistIds.length === 1) {
            for (let el of elements) {
                if (el.picklist) el.optionValues = picklistData as unknown as PicklistItem[];
            }
        }
        for (let el of elements) {
            if (el.picklist) el.optionValues = picklistData[el.picklist];
        }
        return picklistData;
    }
}
